module.exports = __webpack_public_path__ + "static/media/vistara.2d8b8874.webp";